import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TRIGGERS_QUERY_KEY} from "../queryKeys";
import {ReachTrigger} from "./types";

type Variables = {};

const getTriggers = async (): Promise<ReachTrigger[]> => {
  const response = await axiosReachInstance.get<ReachTrigger[], AxiosResponse<ReachTrigger[]>>("/triggers");
  return response.data;
};

export const useGetTriggers = (
  variables: Variables = {},
  options?: BaseQueryOptions<ReachTrigger[], Variables>
): BaseUseQueryResult<ReachTrigger[]> => {
  return useBaseQuery<ReachTrigger[], Variables>([TRIGGERS_QUERY_KEY], getTriggers, variables, options);
};
